import { createContext, useState } from "react";

export const PrivateRouteContext = createContext();

export const PrivateRouteProvider = ({ children }) => {

  const [isLoading, setIsLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(null); // Estado que armazena se o usuário está autenticado ou não

  return (
    <PrivateRouteContext.Provider value={{ isLoading, setIsLoading, authenticated, setAuthenticated }}>
      {children}
    </PrivateRouteContext.Provider>
  );
};